import type { UrqlOperationContext } from 'lib/urqlClient';
import assert from 'assert';
import React from 'react';
import { usePodApiAccessTokenContext } from 'wrappers/PodApiAccessTokenProvider';

import { useWorkspace } from './useWorkspace';

declare global {
  // eslint-disable-next-line vars-on-top
  var __fragmentApiOrigin: string | undefined;
}

export function useCustomerApiContext() {
  const { workspace } = useWorkspace();
  const podApiAccessTokens = usePodApiAccessTokenContext();

  assert(workspace, 'Workspace pod info not found');
  const url = workspace.pod.dashboardCustomerApiUrl;

  // `@fragment-dev/payment-elements` ships one production origin, and a
  // workspace lives on its own pod. Point the SDK at this workspace's host.
  React.useEffect(() => {
    globalThis.__fragmentApiOrigin = new URL(url).origin;
  }, [url]);

  const context: UrqlOperationContext = React.useMemo(
    () => ({
      token: podApiAccessTokens.customerApiToken,
      url,
      workspaceId: workspace.id,
    }),
    [podApiAccessTokens.customerApiToken, url, workspace.id]
  );

  return {
    context,
    token: podApiAccessTokens.customerApiToken,
  };
}
